import { render } from "./ListItemEmpty.vue?vue&type=template&id=03b3635a"
import script from "./ListItemEmpty.vue?vue&type=script&lang=js"
export * from "./ListItemEmpty.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__